//#region import
import React, { Fragment, createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnClearTable, BtnDelete, BtnDeleteTable, BtnDraft, BtnEdit, BtnEditTable, BtnPreview, BtnSave, BtnSend, BtnSendRequest, BtnViewTable } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import { SelectItem } from 'components/Input/Select/SelectItem';
import AccordionPanel from '../components/AccordionPanel';
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import AutoCompleteInTable from 'components/DataGrid/AutoCompleteInTable';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import "../StyleProject.css";
import ChangeOrderCustom from 'components/System/ChangeOrderCustom';
import { useLocation } from 'react-router';
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Panel7 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel9,
        setisChangePanel9,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        nProjectVersionID,
        nLogChangeID,
        ObjCheckSubmitVersion,
        setObjCheckSubmitVersion,
        isChangePanel7,
        setisChangePanel7,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);

    useEffect(() => {
        setisEditSecretary((isModeSecretary === true || nLogChangeID !== null) ? false : isPermission);
    }, [isModeSecretary, nLogChangeID]);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID,]);

    useEffect(() => {
        if (nProjectVersionID !== 0) handleGetFormProjectID();
    }, [nProjectVersionID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel7, { nProjectID: nProjectID, nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID), }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);

            setarrProjectPlan(result.objResult.lstProjectPlan);
            setDataRowPlan({
                ...initRows,
                nDataLength: result.objResult.lstProjectPlan.length,
                arrRows: result.objResult.lstProjectPlan,
            });

            setarrProjectActivity(result.objResult.lstProjectActivity);
            setDataRowActivity({
                ...initRows,
                nDataLength: result.objResult.lstProjectActivity.length,
                arrRows: result.objResult.lstProjectActivity,
            });
        });
    };

    //#region Plan
    const [nProjectPlanIDEdit, setnProjectPlanIDEdit] = useState(0);
    const [ObjPlanIDEdit, setObjPlanIDEdit] = useState(null);
    const [arrProjectPlan, setarrProjectPlan] = useState([]);
    const [DataRowPlan, setDataRowPlan] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formPlan = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sPlan: null,
        } as any,
    });

    // const handleChageOrder = (newValue, oldValue, nID) => {
	// 	//change order
	// 	let nNewOrder = +newValue
	// 	let isOldMoreThanNew = oldValue > nNewOrder;
	// 	let nSetOrder = isOldMoreThanNew ? nNewOrder : oldValue;
    //     let dataRow = DataRowPlan;
    //     let arrPlan = DefaultArrayEmpty(arrProjectPlan);
	// 	arrPlan.forEach(item => {
	// 		if (isOldMoreThanNew) {
	// 			if (oldValue > item.nOrder && nNewOrder <= item.nOrder) {
	// 				item.nOrder = ++nSetOrder;
	// 			}
	// 		} else {
	// 			if (nNewOrder > item.nOrder && oldValue <= item.nOrder) {
	// 				item.nOrder = nSetOrder++;
	// 			}
	// 			if (nNewOrder >= oldValue && nNewOrder === item.nOrder) {
	// 				item.nOrder = oldValue;
	// 			}
	// 		}
	// 		if (nID === item.nID) {
	// 			item.nOrder = nNewOrder;
	// 		}
	// 	});
	// 	// arrPlan.sort((a, b) => a.nOrder - b.nOrder);
    //     arrPlan = new LINQ<any>(arrPlan || []).OrderBy(o=> o.nOrder).ToArray();
	// 	setarrProjectPlan(arrPlan);
    //     setDataRowPlan({
    //         ...dataRow,
    //         nDataLength: arrPlan.length,
    //         arrRows: arrPlan,
    //     });
	// }

    const handleChangeOrder = (nNewOrder, nOldOrder) => {
        let arrPlan = DataRowPlan;
        let arrRowPlan = arrPlan.arrRows;
        let objSelf = arrRowPlan.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowPlan.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowPlan.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowPlan = arrRowPlan.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrPlan.arrRows = [...arrRowPlan];
        setDataRowPlan({ ...arrPlan });
        setarrProjectPlan([...arrRowPlan]);
    };

    const dataColumnPlan : any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Plan_" + item.row.sID}
                                id={"btnDelete_Plan_" + item.row.sID}
                                onClick={() => onDeletePlan(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!item.row.isBtnDelete || !isPermission || isEditSecretary === false}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Plan_" + item.row.sID}
                                id={"btnEdit_Plan_" + item.row.sID}
                                onClick={() => onEditPlan(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Plan_" + item.row.sID}
                            id={"btnView_Plan_" + item.row.sID}
                            onClick={() => onEditPlan(item.row, EnumStatusMode.View)}
                            // IsDisabled={isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                // let lstnOrder = arrProjectPlan.filter(f=> f.nOrder !== 0).map(function(elem) {return { label: elem.nOrder, value: elem.nOrder, }}); //filter(f=> f.nOrder !== item.row.nOrder)
                let lstnOrder = new LINQ<any>(arrProjectPlan || []).Where(w=> w.nOrder !== 0).OrderBy(o=> o.value).Select(function(elem) {return { label: elem.nOrder, value: elem.nOrder, }}).ToArray();
                return (
                    <Grid item xs={12} md={12} key={"nOrder_Plan_" + item.row.sID}>
                        {/* <SelectItem
                            id={`nOrder_${item.row.nID}`}
                            name={`nOrder_${item.row.nID}`}                                
                            required={true}
                            options={lstnOrder} //nOrder
                            disabled={!isPermission || isEditSecretary === false}
                            IsShowMessageError={false}
                            IsClearable={true}
                            defaultValue={item.row.nOrder}
                            onChange={(e) => {
                                //handleChageOrder = (newValue, oldValue, nID, sInputName)
                                handleChageOrder(e.value, item.row.nOrder, item.row.nID, `nOrder_${item.row.nID}`)
                            }}
                        /> */}
                        {/* <AutoCompleteInTable
                            key={"nOrder_" + item.row.sID}
                            small
                            fullWidth={true}
                            objValue={{label: item.row.nOrder, value: item.row.nOrder}}
                            funcOnChange={()=>{}}
                            // funcOnChange={(newValue: any) => {
                            //     // handleChageOrder(newValue.target.innerText, item.row.nOrder, item.row.nID);
                            //     handleChangeOrder(newValue.target.innerText, item.row.nOrder);
                            // }}
                            lstOption={lstnOrder ?? []}
                            disClearable={true}
                            disabled={!isPermission || isEditSecretary === false}
                        /> */}
                        <ChangeOrderCustom
                            id={"nOrder_Plan_" + item.row.sID}
                            item={item.row}
                            value={item.row.nOrder}
                            onChangeOrder={(sID, nOrder) =>
                                handleChangeOrder(+nOrder, +item.row.nOrder)
                            }
                            optOrder={lstnOrder ?? []}
                            IsView={false}
                            disabled={!isPermission || isEditSecretary === false}
                        />
                    </Grid>
                );
            },
        },
        {
            field: "sPlan",
            headerName: "ชื่อแผนงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 5,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },  
    ];

    const onAddPlan = () => {
        let oForm = formPlan.getValues();
        let ObjDuplicate = arrProjectPlan.filter((f) => !f.isDelete && (nProjectPlanIDEdit !== 0 ? f.nID !== nProjectPlanIDEdit : true) && f.sPlan === oForm.sPlan);
        if ((ObjDuplicate || []).length === 0)
        {      
            let nProjectPlanID = 0;
            let dataRow = DataRowPlan;
            let arrPlan = DefaultArrayEmpty(arrProjectPlan);
            let nMaxID = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nOrder) + 1 : 1;
            let isBtnDelete = true;
            if (nProjectPlanIDEdit) {
                arrPlan = arrPlan.filter((f) => f.nID !== nProjectPlanIDEdit);
                nMaxID = nProjectPlanIDEdit;
                let ObjPlan = arrProjectPlan.find((f) => f.nID === nProjectPlanIDEdit);
                nProjectPlanID = ObjPlan?.nProjectPlanID;
                nOrder = ObjPlan?.nOrder;
                isBtnDelete = ObjPlan?.isBtnDelete;
            }
            let obj = {
                isDelete: false,
                isEdit: false, 
                sID: nMaxID.toString(),
                nID: nMaxID,
                nProjectPlanID: nProjectPlanID,
                sPlan: oForm.sPlan,  
                nOrder: nOrder,       
                isBtnDelete: isBtnDelete,         
            };

            let result = [...arrPlan, obj];
            // let nOrder = 1;
            // result.forEach(f => f.nOrder = nOrder++);
            // let arrTable = result.filter(f => !f.isDelete);
            let arrTable = new LINQ<any>(result || []).Where(w=> !w.isDelete).OrderBy(o=> o.nOrder).ToArray();
            setDataRowPlan({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnProjectPlanIDEdit(0);
            setObjPlanIDEdit(null);
            setarrProjectPlan(result);
            onClearFieldPlan();
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldPlan = () => {
        Object.keys(formPlan.getValues()).forEach((key) => {
            formPlan.setValue(key, null);
            formPlan.clearErrors(key);
        });
    };

    const onEditPlan = (ObjData, nModeID : EnumStatusMode) => {
        setnProjectPlanIDEdit(ObjData.nID);   
        let ObjPlan = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nID: ObjData.nID,
            nProjectPlanID: ObjData.nProjectPlanID,
            sPlan: ObjData.sPlan,   
            nOrder: ObjData.nOrder,
            isBtnDelete: ObjData.isBtnDelete, 
        };
        setObjPlanIDEdit(ObjPlan);
        formPlan.setValue("sPlan", ObjPlan.sPlan);

        document.getElementById("myDivPlan").scrollIntoView({ behavior: "smooth" });        
    }

    const onDeletePlan = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrPlanData: any[] = arrProjectPlan;
            let result = arrPlanData.filter((f) => f.nID !== nID);
            let arrDelete = arrPlanData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })
            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => {
                f.nOrder = nOrder++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowPlan({
                ...DataRowPlan,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectPlan([...result, ...arrDelete]);
        });
    };

    useEffect(() => {
        let lstProjectPlan = arrProjectPlan.filter(f=> !f.isDelete && !f.isBtnDelete);
        let lstnPlanID = lstProjectPlan.map(m=> m.nID);
        let lstUpDataActivity = (arrProjectActivity || []).filter(w=> !w.isDelete && lstnPlanID.includes(w.nPlanID));        
        lstUpDataActivity.forEach(iActivity => {
            let ObjPlan = lstProjectPlan.find(f=> !f.isDelete && !f.isBtnDelete && f.nID === iActivity.nPlanID);
            iActivity.ObjPlan = ObjPlan ? {
                                    nID: ObjPlan.nID,
                                    nProjectPlanID: ObjPlan.nProjectPlanID,
                                    sPlan: ObjPlan.sPlan,  
                                    nOrder: ObjPlan.nOrder,       
                                } : null;
        });
        let arrTable = new LINQ<any>(lstUpDataActivity || []).OrderBy(o=> o.ObjPlan.nOrder).ToArray();
        setDataRowActivity({
            ...DataRowActivity,
            nDataLength: arrTable.length,
            arrRows: arrTable,
        });
        setarrProjectActivity(arrTable);
    }, [arrProjectPlan]);

    //#endregion

    //#region Activity
    const [isExpandedActivity, setisExpandedActivity] = useState(true);
    const [nActivityIDEdit, setnActivityIDEdit] = useState(0);
    const [ObjActivityIDEdit, setObjActivityIDEdit] = useState(null);
    const [arrProjectActivity, setarrProjectActivity] = useState([]);
    const [DataRowActivity, setDataRowActivity] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formActivity = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nPlanID: null,
            sActivity: null,
            sMethod: null,
            sArea: null,
            sResult: null,
        } as any,
    });

    const onAddActivity = () => {
        let oForm = formActivity.getValues();
        let ObjDuplicate = arrProjectActivity.filter((f) => !f.isDelete && (nActivityIDEdit !== 0 ? f.nID !== nActivityIDEdit : true) && f.sActivity === oForm.sActivity && f.sSolution === oForm.sSolution);
        if ((ObjDuplicate || []).length === 0)
        {      
            let nActivityID = 0;
            let dataRow = DataRowActivity;
            let arrActivity = DefaultArrayEmpty(arrProjectActivity);
            let nMaxID = new LINQ<any>(arrActivity).Any() ? new LINQ<any>(arrActivity).Max((m) => m.nID) + 1 : 1;
            // let nOrder = new LINQ<any>(arrActivity).Any() ? new LINQ<any>(arrActivity).Max((m) => m.nNo) + 1 : 1;
            let nOrder = new LINQ<any>(arrActivity).Where(w=> w.nPlanID === oForm.nPlanID).Any() ? new LINQ<any>(arrActivity).Where(w=> w.nPlanID === oForm.nPlanID).Max((m) => m.nNo) + 1 : 1;
            if (nActivityIDEdit) {
                arrActivity = arrActivity.filter((f) => f.nID !== nActivityIDEdit);
                nMaxID = nActivityIDEdit;
                // nActivityID = arrProjectActivity.find((f) => f.nID === nActivityIDEdit)?.nActivityID;
                let ObjActivity = arrProjectActivity.find((f) => f.nID === nActivityIDEdit);
                nActivityID = ObjActivity?.nActivityID;
                nOrder = ObjActivity?.nNo;
            }
            let ObjPlan = new LINQ<any>(arrProjectPlan || []).FirstOrDefault(w=> !w.isDelete && w.nID === oForm.nPlanID); //nID, sPlan: elem.sPlan
            let obj = {
                isDelete: false,
                isEdit: false, 
                sID: nMaxID.toString(),
                nID: nMaxID,
                nNo: nOrder,
                nActivityID: nActivityID,
                sActivity: oForm.sActivity,
                sMethod: oForm.sMethod,
                sArea: oForm.sArea,
                sResult: oForm.sResult,
                nPlanID: oForm.nPlanID,
                ObjPlan: ObjPlan ? {
                            nID: ObjPlan.nID,
                            nProjectPlanID: ObjPlan.nProjectPlanID,
                            sPlan: ObjPlan.sPlan,  
                            nOrder: ObjPlan.nOrder,       
                        } : null,
            };

            // let nNo = 1;
            // let result = [...arrActivity, obj];
            // result.forEach(f => f.nNo = nNo++);
            // let arrTable = result.filter(f => !f.isDelete);

            let result = [...arrActivity, obj];
            let arrTable = new LINQ<any>(result || []).Where(w=> !w.isDelete).OrderBy(o=> o.nNo).ToArray();

            setDataRowActivity({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnActivityIDEdit(0);
            setObjActivityIDEdit(null);
            setarrProjectActivity(result);
            onClearFieldActivity();

            let lstnPlanID = arrTable.map(m=> m.nPlanID);
            let dataRowPlan = DataRowPlan;
            let arrPlan = DefaultArrayEmpty(DataRowPlan.arrRows);
            arrPlan.filter(f=> lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = false;});
            setDataRowPlan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldActivity = () => {
        Object.keys(formActivity.getValues()).forEach((key) => {
            formActivity.setValue(key, null);
            formActivity.clearErrors(key);
        });
    };

    const onEditActivity = (ObjData, nModeID : EnumStatusMode) => {
        setnActivityIDEdit(ObjData.nID);   
        let ObjActivity = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nActivityID: ObjData.nActivityID,  
            sActivity: ObjData.sActivity,
            sMethod: ObjData.sMethod,
            sArea: ObjData.sArea,
            sResult: ObjData.sResult,
            nPlanID: ObjData.nPlanID,
            ObjPlan: ObjData.ObjPlan,  
        };
        setObjActivityIDEdit(ObjActivity);
        formActivity.setValue("nPlanID", ObjActivity.nPlanID);
        formActivity.setValue("sActivity", ObjActivity.sActivity);
        formActivity.setValue("sMethod", ObjActivity.sMethod);
        formActivity.setValue("sArea", ObjActivity.sArea);
        formActivity.setValue("sResult", ObjActivity.sResult);
        setisExpandedActivity(false);

        document.getElementById("myDivActivity").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteActivity = (ObjData, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrActivityData: any[] = arrProjectActivity;
            let result = arrActivityData.filter((f) => f.nID !== ObjData.nID);
            let arrDelete = arrActivityData.filter((f) => f.nID === ObjData.nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nNo = 0;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete && f.nPlanID === ObjData.nPlanID).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowActivity({
                ...DataRowActivity,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            let lstDataProjectActivity = [...result, ...arrDelete];
            setarrProjectActivity([...result, ...arrDelete]);

            let lstnPlanID = lstDataProjectActivity.filter(f => !f.isDelete).map(m=> m.nPlanID);
            let dataRowPlan = DataRowPlan;
            let arrPlan = DefaultArrayEmpty(DataRowPlan.arrRows);
            arrPlan.filter(f=> !lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = true;});
            setDataRowPlan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        });
    };

    const CallTableActivity = useCallback(() => {
        let lstDataPlan = new LINQ<any>(DataRowActivity.arrRows || []).Where(w=> !w.isDelete).Select(s=> s.ObjPlan ).Distinct().ToArray() ?? [];
        lstDataPlan = new LINQ<any>(lstDataPlan || []).OrderBy(o=> o.nOrder).ToArray();
        let lstDataActivity = DataRowActivity.arrRows ?? [];

        return (
            <TableContainer id='table-activity' component={Paper}>
                <Table sx={{ minWidth: 1000 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '95px', width: '95px' }}></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '400px', width: '400px' }}>แผนงาน/กิจกรรม</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '160px', width: '160px' }}>วิธีการดำเนินงาน</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '160px', width: '160px' }}>{ParseHtml("พื้นที่ดำเนินการและ/<br/>หรือกลุ่มเป้าหมาย")}</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '160px', width: '160px' }}>{ParseHtml("ผลผลิต<br/>ที่ได้จากการดำเนินงาน")}</TableCell>
                        </TableRow>
                    </TableHead>                   
                        {lstDataPlan.map((iPlan) => {
                            return (
                                <TableBody>
                                    <TableRow key={`sID_Plan_${iPlan.nID}`}>
                                        <TableCell className='bg-color' colSpan={5} align="left">{"แผนงานที่ " + iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                    </TableRow>
                                    {/* new LINQ<any>(lstDataActivity || []).Where(w=> w.f=> f.nPlanID === iPlan.nID).OrderBy(o=> o.nOrder).ToArray().forEach */}
                                    {lstDataActivity.filter(f=> f.nPlanID === iPlan.nID).sort(s=> s.nNo).map((iActivity) => {
                                        return (
                                            <TableRow key={`sID_Activity_${iActivity.sID}`}>
                                                <TableCell align="center">
                                                    {(!iActivity.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                        <Grid item xs={12} md={12} container spacing={1} key={`Btn_${iActivity.nID}`}>
                                                            <Grid item>
                                                                <BtnDeleteTable
                                                                    key={"btnDelete_Activity_" + iActivity.nID}
                                                                    id={"btnDelete_Activity_" + iActivity.nID}
                                                                    onClick={() => onDeleteActivity(iActivity, EnumStatusMode.Delete)}
                                                                    IsDisabled={!isPermission || isEditSecretary === false}
                                                                    IsCircleWithOutText={true}
                                                                />   
                                                            </Grid>   
                                                            <Grid item>
                                                                <BtnEditTable
                                                                    key={"btnEdit_Activity_" + iActivity.nID}
                                                                    id={"btnEdit_Activity_" + iActivity.nID}
                                                                    onClick={() => onEditActivity(iActivity, EnumStatusMode.Edit)}
                                                                    IsDisabled={!isPermission || isEditSecretary === false}
                                                                    IsCircleWithOutText={true}
                                                                />
                                                            </Grid>                                                           
                                                        </Grid>
                                                        :
                                                        <BtnViewTable
                                                            key={"btnPreview_Activity_" + iActivity.nID}
                                                            id={"btnPreview_Activity_" + iActivity.nID}
                                                            onClick={() => onEditActivity(iActivity, EnumStatusMode.View)}
                                                            // IsDisabled={isPermission || isEditSecretary === false}
                                                            IsCircleWithOutText={true}
                                                        />
                                                    }
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml("กิจกรรมที่ " + iPlan.nOrder + "." + iActivity.nNo + " " + iActivity.sActivity)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iActivity.sMethod)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iActivity.sArea)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iActivity.sResult)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}    
                                </TableBody>
                            )})
                        }
                        {lstDataPlan.length === 0 ?
                            <StyledTableRow key={`sID_Activity`}>
                                <TableCell align="center" colSpan={5}>ไม่พบข้อมูล</TableCell>
                            </StyledTableRow>
                            :
                            null
                        }                    
                </Table>
            </TableContainer>
            // <BtnViewTable
            //     key={"btnPreview_" + iActivity.nID}
            //     id={"btnPreview_" + iActivity.nID}
            //     onClick={() => onEditActivity(iActivity.nID, EnumStatusMode.View)}
            //     // IsDisabled={!isPermission || isEditSecretary === false}
            //     IsCircleWithOutText={true}
            // />
            // <BtnClearTable
            //     key={"btnClear_" + iActivity.nID}
            //     id={"btnClear_" + iActivity.nID}
            //     onClick={() => onEditActivity(iActivity.nID, EnumStatusMode.View)}
            //     // IsDisabled={!isPermission || isEditSecretary === false}
            //     IsCircleWithOutText={true}
            // />
        );
    }, [DataRowActivity.arrRows, isEditSecretary]);
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (nModeID === EnumSaveModeProject.Submit) {
            if (arrProjectActivity.filter(f => !f.isDelete).length === 0) {
                return DialogFn.Warning("กรุณาเพิ่มข้อมูลกิจกรรมอย่างน้อย 1 รายการ");
            } 

            //ต้องมีกิจกรรมในทุกแผนงานที่เพิ่มมาทั้งหมด
            if (arrProjectPlan.filter(f => f.isBtnDelete && !f.isDelete).length > 0) {
                return DialogFn.Warning("กรุณาเพิ่มข้อมูลกิจกรรมให้ครบทุกแผนงาน");
            } 
        }
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel7,
            isFastTrack: isFastTrack,

            lstProjectPlan: arrProjectPlan,
            lstProjectActivity: arrProjectActivity,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel7, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 7, isEdit: false});
                        setisChangePanel9(true);
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);

                        if (nModeID === EnumSaveModeProject.Submit && nStatusID !== EnumProjectStatusID.nStatusID_0) { setisChangePanel7(true); setisCheck(true); }
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    //#region CheckSubmit โหมดแก้ไข เช็คเงื่อนไขกรณีข้อมูลที่อยู่ บันทึกพร้อมส่ง และมีการแก้ข้อมูลไป และมีความสัมพันธ์ Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
    const [isCheck, setisCheck] = useState(false);
    const [isCheckError, setIsCheckError] = useState(false);

    useEffect(() => {
        if (isChangePanel9 === false && isChangePanel7 === false && isCheck === true) { 
            document.getElementById("btnCheck_Panel9_ChangeStatus").click(); 
            setIsCheckError(true); 
        }
    }, [isChangePanel9, isChangePanel7, isCheck]);

    useEffect(() => {
        if (isCheckError === true) {            
            if (ObjCheckSubmitVersion?.isPanel9 === true) {
                if (ObjCheckSubmitVersion?.isWorkPlan === false) {
                    document.getElementById("btnCheck_WorkPlan_ChangeStatus").click();
                }
                setisCheck(false);
            }
            if (ObjCheckSubmitVersion?.isPanel9 === true && ObjCheckSubmitVersion?.isWorkPlan === true) handleCheckPlan();         
        }  
    }, [isCheckError, ObjCheckSubmitVersion]);

    const handleCheckPlan = () => {
        let param = {
            nProjectID: nProjectID,
            nPanelID: EnumProjectPanel.Panel7,

            sMessagePanel: ((ObjCheckSubmitVersion?.sWarningPanel9 ?? "") + (ObjCheckSubmitVersion?.sWarningWorkPlan ?? "")),
            isComplete_Panel9: (ObjCheckSubmitVersion?.sWarningPanel9 === null || ObjCheckSubmitVersion?.sWarningPanel9 === "") ? true : false,
            isComplete_WorkPlan: (ObjCheckSubmitVersion?.sWarningWorkPlan === null || ObjCheckSubmitVersion?.sWarningWorkPlan === "") ? true : false,
            // isComplete_SpendingPlan: (ObjCheckSubmitVersion?.sWarningSpendingPlan === null || ObjCheckSubmitVersion?.sWarningSpendingPlan === "") ? true : false,
            // sMessagePanel: ((ObjCheckSubmitVersion?.sWarningPanel9 ?? "") + (ObjCheckSubmitVersion?.sWarningWorkPlan ?? "") + (ObjCheckSubmitVersion?.sWarningSpendingPlan ?? "")),
        };
        AxiosFn.Post(ApiProject.SaveProjectCheckPlan, param, (result) => {
            if (result.nStatusCode === APIStatusCode.Warning) {
                DialogFn.Warning(result.sMessage);             
            }
            setisChangePanel9(true);
            setisChangePanel7(true);
            setObjCheckSubmitVersion({
                isPanel9: false,
                sWarningPanel9: null,
                isWorkPlan: false,
                sWarningWorkPlan: null,
                isSpendingPlan: false,
                sWarningSpendingPlan: null,
            }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
            setIsCheckError(false);
        });
    }
    //#endregion

    return (
        <AccordionPanel
            header={"7. แผนการดำเนินงาน"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >      
            <Grid id={"myDivPanel7"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <Grid item xs={12} md={12} container spacing={2}>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item>
                            <Typography variant='h6' color={'#0000a5'}>แผนการดำเนินงาน</Typography>
                        </Grid>
                        <Grid item>
                            <Tooltip placement={'right-end'} title={"ระบุกิจกรรมที่จะดำเนินการ โดยอธิบายขั้นตอนการดำเนินกิจกรรมอย่างละเอียด"}>
                                <ErrorIcon color='primary'/>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Divider />
                        </Grid>
                    </Grid>    
                    <Grid id={"myDivPlan"} item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"กำหนดแผนงาน"}
                            isExpanded={false} 
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >           
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formPlan}>
                                    <Grid item xs={12} md={12}>
                                        <TextBoxItem
                                            id={"sPlan"}
                                            name={"sPlan"}
                                            type={"text"}
                                            label={"ชื่อแผนงาน"}
                                            placeholder={"ระบุเฉพาะชื่อแผนงาน"}
                                            required={true}
                                            maxLength={500}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid> 
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {(nProjectPlanIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                            <BtnAdd id={"btnAdd_Table_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มแผนงาน"} onClick={formPlan.handleSubmit((e) => onAddPlan(),(err) => console.log("err", err))} />
                                            :
                                            <>
                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formPlan.handleSubmit((e) => onAddPlan(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                }
                                                {nProjectPlanIDEdit !== 0 &&
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Table_Plan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectPlanIDEdit(0); setObjPlanIDEdit(null); onClearFieldPlan(); }} />
                                                    </Grid>
                                                }             
                                            </>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <DataGrid
                                            sTableID='TB_ProjectPlan'
                                            columns={dataColumnPlan}
                                            rows={DataRowPlan}
                                            isShowColomnTool={false}
                                            isHiddenToolHead={true}
                                            isShowCheckBox={false}
                                            isHiddenPagination={false}
                                        />
                                    </Grid>
                                </FormProvider>
                            </Grid> 
                        </AccordionPanel> 
                    </Grid>            
                    <Grid id={"myDivActivity"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                        <AccordionPanel
                            header={"กำหนดกิจกรรม"}
                            isExpanded={false} //{isExpandedActivity} 
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formActivity}>
                                    <Grid item xs={12} md={6}>
                                        <SelectItem
                                            id="nPlanID"
                                            name={"nPlanID"}
                                            label={"ชื่อแผนงาน"}
                                            // options={arrProjectPlan.filter(f => !f.isDelete).map(function(elem) {return { label: "แผนงานที่ " + elem.nOrder + "." + elem.sPlan, value: elem.sPlan, }})}
                                            options={new LINQ<any>(arrProjectPlan || []).Where(w=> !w.isDelete).OrderBy(o=> o.nOrder).Select(function(elem) {return { label: "แผนงานที่ " + elem.nOrder + ". " + elem.sPlan, value: elem.nID, sPlan: elem.sPlan }}).ToArray()}
                                            required={true}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextBoxItem
                                            id={"sActivity"}
                                            name={"sActivity"}
                                            type={"text"}
                                            label={"ชื่อกิจกรรม"}
                                            required={true}
                                            maxLength={500}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid>                                         
                                    <Grid item xs={12} md={12}>
                                        <TextAreaItem
                                            id={"sMethod"}
                                            name={"sMethod"}
                                            label={"วิธีการดำเนินงาน (โดยใคร อย่างไร ที่ไหน)"}                               
                                            required={true}
                                            maxLength={500}
                                            row={3}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextAreaItem
                                            id={"sArea"}
                                            name={"sArea"}
                                            label={"พื้นที่ดำเนินการและ/หรือกลุ่มเป้าหมาย (ดำเนินการในพื้นที่ไหน เพื่อใคร ระบุจำนวน)"}                               
                                            required={true}
                                            maxLength={500}
                                            row={3}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextAreaItem
                                            id={"sResult"}
                                            name={"sResult"}
                                            label={"ผลผลิตที่ได้จากการดำเนินงาน"}                               
                                            required={true}
                                            maxLength={500}
                                            row={3}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {(nActivityIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                            <BtnAdd id={"btnAdd_Table_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มกิจกรรม"} onClick={formActivity.handleSubmit((e) => onAddActivity(),(err) => console.log("err", err))} />
                                            :
                                            <>
                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formActivity.handleSubmit((e) => onAddActivity(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                }
                                                {nActivityIDEdit !== 0 &&
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Table_Activity"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnActivityIDEdit(0); setObjActivityIDEdit(null); onClearFieldActivity(); }} />
                                                    </Grid>   
                                                }               
                                            </>
                                        }
                                    </Grid>                                    
                                </FormProvider>
                            </Grid>
                        </AccordionPanel>
                    </Grid>            
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                        <CallTableActivity />
                    </Grid>
                    {nProjectID === 0 || (nStatusID === EnumProjectStatusID.nStatusID_11 && nLogChangeID === null) ?
                        <></>
                        :      
                        (isPermission === true &&
                            (isModeSecretary !== true ?
                                <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                    {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                        <Grid item>
                                            <BtnDraft id={"btnDraft_Panel7"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                        </Grid>
                                    }
                                    <Grid item>
                                        <BtnSendRequest id={"btnSend_Panel7"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                    </Grid> 
                                </Grid>   
                            : 
                                (isModeSecretary === true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {isEditSecretary === false ?
                                            <Grid item>
                                                <BtnEdit id={"btnEdit_Panel7"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel7").scrollIntoView({ behavior: "smooth" });}} />
                                            </Grid>
                                            :
                                            <>
                                                <Grid item>
                                                    <BtnCancel id={"btnCancel_Panel7"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                </Grid>
                                                <Grid item>
                                                    <BtnSendRequest id={"btnSend_Panel7"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                                </Grid>
                                            </>
                                        }   
                                    </Grid>
                                    : <></>
                                )
                            )
                        )
                    }     
                </Grid>     
            </Grid>
        </AccordionPanel>
    )
}
export default Panel7;
